import { Component } from '@angular/core';
import { BaseFpxROGridComponent } from '@fpx/core';
import {EMICalculationDisplayGridHelper } from './emi-calculation-display-grid.helper';
import { EmicalculationService } from '../emicalculation-service/emicalculation.service';
import { Emicalculation } from '../emicalculation-service/emicalculation.model';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/common.service';

@Component({
 selector: 'app-emi-calculation-display-grid',
  templateUrl: './emi-calculation-display-grid.component.html',
  styleUrls: ['./emi-calculation-display-grid.component.scss'],
  providers:[EMICalculationDisplayGridHelper]
 })
export class EMICalculationDisplayGridComponent extends BaseFpxROGridComponent< Emicalculation, EMICalculationDisplayGridHelper> {
 constructor(
    public eMICalculationDisplayGridHelper: EMICalculationDisplayGridHelper,
    protected emicalculationService: EmicalculationService,
    public commonService:CommonService,
     _router:Router
  ) {
    super(eMICalculationDisplayGridHelper,_router);
  }
  
  protected override doPreInit(): void {
    this.setGridHeaders([]);
    this.setGridIdentifiers([]);
    this.setGridColumnTypes([]);
    this.addGridDataService(this.emicalculationService);
    this.setGridTitle('Loan Details');
  }
}
